import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface RootCausesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<RootCausesServiceData>(db, 'rootCausesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
